// Financial Crime and KYC oversight: the routes and the sidebar rows of `wealth.compliance.fin-crime-kyc` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.fin-crime-kyc',
    routes: [
        {
            frontend: 'comply',
            path: 'fin-crime-kyc',
            lazy: () => import('@/pages/comply/fin-crime-kyc/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'fin-crime-kyc',
            label: 'Financial Crime & KYC',
            href: '/comply/fin-crime-kyc',
            icon: 'AlertTriangle',
            group: 'clients-kyc',
            order: 320,
            wip: true,
        },
    ],
});
